<template>
  <div id="documents" class="documents">
    <div class="file-table">
      <table class="table">
        <tr>
          <td>转单号：{{ bookingInfo.transferNo }}</td>
          <td v-if="!bookingInfo.transferAddress" class="title">
            {{ bookingInfo.startAddressEn }}{{ bookingInfo.startAddress }}-->{{ bookingInfo.destAddressEn }}{{ bookingInfo.destAddress }}
          </td>
          <td v-else="!bookingInfo.transferAddress" class="title">
            {{ bookingInfo.startAddressEn }}{{ bookingInfo.startAddress }}-->{{ bookingInfo.transferAddressEn }}{{ bookingInfo.transferAddress }}-->{{ bookingInfo.destAddressEn }}{{ bookingInfo.destAddress }}
          </td>
        </tr>
        <tr>
          <td>船公司：{{ bookingInfo.shipCompanyName }}</td>
          <td>ETD：{{ bookingInfo.etd }}</td>
        </tr>
        <tr>
          <td>船名航次:{{ bookingInfo.shipName }}/{{ bookingInfo.shipNum }}</td>
          <td>ETA：{{ bookingInfo.eta }}</td>
        </tr>
      </table>
    </div>
    <div class="flex">
      <div id="allmap" ref="mapContainer" class="map" />

      <el-timeline :reverse="false">
        <el-timeline-item
          v-for="(item,index) in list"
          v-if="item.status.indexOf('扣件')<0"
          :key="index"
          :hide-timestamp="true"
          placement="top"
          :timestamp="item.date"
        >
          <div>
            <span style="font-weight: 600;">{{ item.status }}</span>
            <span style="margin-left: 20px;">{{ item.dateStr ||xms.toDate(item.date) }}</span>
            <p v-if="item.status!='已订舱'&&item.status!='已配载'">{{ item.descriptionOuter||item.description }}</p>
            <p v-else>
              {{ item.descriptionOuter||item.description }}，船名：{{ bookingInfo.shipName }}，船次：{{ bookingInfo.shipNum }}{{ bookingInfo.isShowContainerNo==1?'，柜号：'+bookingInfo.containerNo:'' }}
            </p>
            <p v-if="item.location">地点：{{ item.location }}</p>
          </div>
        </el-timeline-item>
      </el-timeline>
    </div>
  </div>
</template>

<script>
import {
  GetOrderTrack
} from '@/api/order.js'
import request from '@/utils/request'
export default {
  name: 'Documents',
  components: {
    // 组件的引用
  },
  props: {
    // 父辈向子辈传参
  },
  data() {
    return {
      data: {},
      list: [],
      map: undefined,
      bookingInfo: {},
      startLatitude: 114.259951,
      startLongitude: 22.57478,
      destLatitude: -122.10487,
      destLongitude: 52.475481
    }
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
  },
  created() {

  },
  mounted() {
    // 页面进入时加载内容
  },
  beforeDestroy() {
    this.destroyMap()
  },
  methods: {
    init(data) {
      this.data = data

      this.getBookingInfo()
    },
    getOrderTrack() {
      var url = ''
      if (this.bookingInfo.isShowContainerNo == 1) {
        url = 'GetSpecialOrderGTrack'
      } else {
        url = 'GetOrderGTrack'
      }
      request({
		  url: `/api/webapi/order/${url}/${this.data.orderNo}`,
		  method: 'GET',
		  data: { orderNo: this.data.orderNo },
		  headers: {
		    Authorization: this.token
		  }
      }).then(res => {
		  if (res.code == 200) {
		    this.list = res.data
		    this.list.forEach(item => {
		      if (item.date) {
		        item.date = this.xms.toDate(item.date)
		      }
		    })
		  }
      })
    },
    getBookingInfo() {
      request({
        url: `/api/webapi/order/GetBookingInfo/${this.data.orderNo}`,
        method: 'GET',
        headers: {
          Authorization: this.token
        }
      }).then((res) => {
        this.bookingInfo = res.data
        if (this.bookingInfo.startLatitude) {
          this.startLatitude = this.bookingInfo.startLatitude
        }
        if (this.bookingInfo.startLongitude) {
          this.startLongitude = this.bookingInfo.startLongitude
        }
        if (this.bookingInfo.destLatitude) {
          this.destLatitude = this.bookingInfo.destLatitude
        }
        if (this.bookingInfo.destLongitude) {
          this.destLongitude = this.bookingInfo.destLongitude
        }
        this.getOrderTrack()
        this.initMap()
      })
    },
    initMap() {
      this.$nextTick(() => {
        const container = this.$refs.mapContainer
        if (!container) return
        // 设置容器尺寸（重要！）
        container.style.width = '800px'
        container.style.height = '500px'
        this.map = new BMap.Map(container)
        var point = new BMap.Point(86.252810, 22.566985)
        this.map.centerAndZoom(point, 3)
        this.map.enableScrollWheelZoom()
        this.map.addControl(new BMap.NavigationControl())
        this.addPolyline()
        var startPoint = new BMap.Point(this.startLatitude, this.startLongitude)
        var marker = new BMap.Marker(startPoint)
        this.map.addOverlay(marker)
        var destPoint = new BMap.Point(this.destLatitude, this.destLongitude)
        var destMarker = new BMap.Marker(destPoint)
        this.map.addOverlay(destMarker)
      })
    },
    addPolyline() {
      const path = [
        new BMap.Point(this.startLatitude, this.startLongitude),
        new BMap.Point(this.destLatitude, this.destLongitude)
      ]

      const polyline = new BMap.Polyline(path, {
        strokeColor: '#2A91FD',
        strokeWeight: 2,
        strokeOpacity: 0.5,
        strokeStyle: 'dashed' // 虚线样式
      })

      this.map.addOverlay(polyline)
    },
    destroyMap() {
      if (this.map) {
        this.map.clearOverlays()
        // this.map.destroy()
        this.map = null
      }
    }
  }
}
</script>
<style scoped lang='scss'>
	.documents {
		padding: 8px 24px 8px 32px;
		background: #FFFFFF;
		text-align: left;
		margin-top: 16px;
		border-radius: 8px;

		.file-table {
			display: flex;

			.left-table {
				border: 1px solid rgba(221, 221, 221, 0.56);
				border-radius: 8px;
				width: 800px;
				border-collapse: collapse;
				text-align: left;
				padding: 0 8px;

				tr:nth-of-type(1) {
					td {
						font-size: 14px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						color: #777777;
						background: rgba(221, 221, 221, 0.24);
						width: 200px;
					}
				}

				tr {
					height: 40px;

					td {
						padding-left: 8px;
						font-size: 14px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						color: #333333;
						width: 200px;

						.division-line {
							display: inline-block;
							height: 20px;
							width: 100%;
							border-right: 1px solid #DDDDDD;
						}

						.blue {
							color: #027FFC;
							cursor: pointer;
						}
					}
				}
			}

			.right-table {
				vertical-align: inherit !important;
				margin-left: 15px;
				border: 1px solid rgba(221, 221, 221, 0.56);
				border-radius: 8px;
				width: 322px;
				border-collapse: collapse;
				text-align: left;
				padding: 0 8px;

				tr:nth-of-type(1) {
					td {
						font-size: 14px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						color: #777777;
						background: rgba(221, 221, 221, 0.24);
						width: 200px;
					}
				}

				tr {
					td {
						height: 40px;
						padding-left: 8px;
						font-size: 14px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						color: #333333;
						width: 200px;

						.division-line {
							display: inline-block;
							height: 20px;
							width: 100%;
							border-right: 1px solid #DDDDDD;
						}

						.blue {
							color: #027FFC;
							cursor: pointer;
						}
					}
				}
			}
		}

		.add-button {
			text-align: right;

			button {
				width: 200px;
				height: 32px;
				background: rgba(2, 127, 252, 0);
				border-radius: 8px;
				border: 1px solid rgba(2, 127, 252, 0.4);
				font-size: 14px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				color: #027FFC;
				margin: 8px 0px 16px 0;

				span {
					margin-right: 4px;
				}
			}
		}

		.documents-title {
			text-align: left;
			font-size: 14px;
			font-family: PingFangSC, PingFang SC;
			margin-bottom: 8px;

			span:nth-of-type(1) {
				font-weight: 500;
				color: #333333;
			}

			span:nth-of-type(2) {
				font-weight: 400;
				color: #777777;
			}
		}

		.map {}

		.table {
			width: 100%;
			margin-top: 10px;
			margin-bottom: 15px;
			font-size: 14px;
		}

		.table td {
			width: 50%;
		}

		.table .title {
			font-weight: 600;
			font-size: 16px;
		}

		.anchorBL {
			display: none !important;
		}
	}

	#allmap {
		width: 800px;
		height: 500px;
		overflow: hidden;
		margin: 0;
		font-family: "微软雅黑";
		display: block;
	}

	/* 穿透百度地图默认控件样式 */
	:deep(.BMap_cpyCtrl) {
		display: none;
	}

	:deep(.anchorBL) {
		display: none;
	}
</style>
